import { bindable, containerless, autoinject } from "aurelia-framework";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import DatePicker from "tui-date-picker";
import { Config } from '../../../config';
import { LanguageService } from '../../../services/language';
import moment from "moment";


@autoinject
@containerless
export class DatePickerCustomElement {
	constructor(private _ea: EventAggregator, private _language: LanguageService) {
	}

	@bindable date: Date;
	dateChanged() {
		if (this.date)
			console.debug("DatePicker.dateChanged: " + this.date.toString());
		else
			console.debug("DatePicker.dateChanged: <null>");
		if (this._datePicker) {
			this._datePicker.setDate(this.date);
		}
	}

	elDate: HTMLInputElement;
	elPicker: HTMLDivElement;

	private _datePicker: DatePicker;
	private _lang: Subscription;


	attached() {
		this._lang = this._ea.subscribe(Config.eventLangChanged, this.onLanguageChanged);
		this.initDatePicker();
	}

	detached() {
		this._lang.dispose();
		this._datePicker.off("change")
	}

	private inputDateValueChanged() {
		const dateText = this.elDate.value;
		if (!dateText || dateText.length === 0) {
			this._datePicker.setNull();
			this.date = this._datePicker.getDate();
			console.debug("inputDateValueChanged: setNull");
		}
	}

	public static initLocales() {
		DatePicker.localeTexts['de'] = {
			// From https://www.expatrio.com/living-germany/learn-german/german-months
			titles: {
				// days
				DD: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
				// daysShort
				D: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
				// months
				MMMM: [
					'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
					'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
				],
				// monthsShort
				MMM: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
			},
			titleFormat: 'MMMM yyyy',
			todayFormat: 'DD, d. MMMM, yyyy',
			date: 'Datum',
			time: 'Zeit'
		};
		DatePicker.localeTexts['hr'] = {
			titles: {
				// days
				DD: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
				// daysShort
				D: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
				// months
				MMMM: [
					'siječanj', 'veljača', 'ožujak', 'travanj', 'svibanj', 'lipanj',
					'srpanj', 'kolovoz', 'rujan', 'listopad', 'studeni', 'prosinac'
				],
				// monthsShort
				MMM: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro']
			},
			titleFormat: 'MMMM yyyy',
			todayFormat: 'DD, d. MMMM, yyyy',
			date: 'Datum',
			time: 'Vrijeme'
		};
	}

	private initDatePicker() {
		this._datePicker = new DatePicker(this.elPicker, {
			date: this.date,
			input: {
				element: this.elDate,
				format: "yyyy-MM-dd"
			},
			usageStatistics: false
		});
		// set language
		this.setDatePickerLanguage(this._language.CurrentLang);
		// set date
		if (this.date) {
			this._datePicker.setDate(this.date);
			console.debug("initDatePicker setDate: " + this.date.toString());
		}

		this._datePicker.on('change', () => {
			this.date = this._datePicker.getDate();
		});
	}

	private setDatePickerLanguage(lang) {
		this._datePicker.changeLanguage(lang);
	}

	private onLanguageChanged = (lang) => {
		this.setDatePickerLanguage(lang);
	}
}
